// =========================
// 📜 MENTIONS LEGALES & CONFORMITÉ
// ========================

import React from 'react';
import { ArrowLeft, Scale, ShieldCheck, Lock, database, Server, HardDrive, Mail } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function MentionsLegales() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-slate-50 py-12 px-4 font-sans text-slate-900">
      <div className="max-w-4xl mx-auto">

        <button
          onClick={() => navigate(-1)}
          className="mb-8 text-slate-500 hover:text-blue-600 flex items-center gap-2 transition-colors font-medium bg-white px-4 py-2 rounded-lg border border-slate-200 shadow-sm w-fit"
        >
          <ArrowLeft className="w-4 h-4" /> Retour
        </button>

        <div className="bg-white p-8 md:p-12 rounded-3xl shadow-xl border border-slate-200 overflow-hidden relative">
          {/* Decorative background element */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-blue-50 rounded-full blur-3xl -mr-32 -mt-32 opacity-50 pointer-events-none"></div>

          <div className="flex items-center gap-5 mb-12 pb-10 border-b border-slate-100 relative z-10">
            <div className="bg-blue-600 p-4 rounded-2xl shadow-lg shadow-blue-200">
              <Scale className="w-8 h-8 text-white" />
            </div>
            <div>
              <h1 className="text-4xl font-black text-slate-900 tracking-tight">Mentions Légales & Conformité</h1>
              <p className="text-slate-500 mt-2 font-medium flex items-center gap-2">
                <ShieldCheck className="w-4 h-4 text-emerald-500" />
                Votre sécurité et votre vie privée sont nos priorités.
              </p>
            </div>
          </div>

          <div className="grid md:grid-cols-1 gap-12 text-slate-600 leading-relaxed relative z-10">

            {/* 1. ÉDITEUR */}
            <section className="bg-slate-50/50 p-8 rounded-3xl border border-slate-100">
              <h2 className="text-sm font-black text-blue-600 mb-6 uppercase tracking-[0.2em] flex items-center gap-2">
                <div className="w-1.5 h-6 bg-blue-600 rounded-full"></div>
                1. Éditeur du site
              </h2>
              <div className="grid sm:grid-cols-2 gap-6">
                <div className="space-y-3">
                  <p><span className="text-xs font-bold text-slate-400 uppercase block mb-1">Raison sociale</span> <span className="text-slate-900 font-bold text-lg">Quest-IA</span></p>
                  <p><span className="text-xs font-bold text-slate-400 uppercase block mb-1">Capital social</span> <span className="text-slate-900 font-bold text-lg">10 000 €</span></p>
                  <p><span className="text-xs font-bold text-slate-400 uppercase block mb-1">RCS</span> <span className="text-slate-900 font-bold text-lg">[Numéro RCS] - Paris</span></p>
                </div>
                <div className="space-y-3">
                  <p><span className="text-xs font-bold text-slate-400 uppercase block mb-1">Siège social</span> <span className="text-slate-900 font-bold text-lg">France</span></p>
                  <p><span className="text-xs font-bold text-slate-400 uppercase block mb-1">Email contact</span> <a href="mailto:contact@quest-ia.fr" className="text-blue-600 font-bold text-lg hover:underline flex items-center gap-2">contact@quest-ia.fr <Mail size={16} /></a></p>
                  <p><span className="text-xs font-bold text-slate-400 uppercase block mb-1">Directeur de publication</span> <span className="text-slate-900 font-bold text-lg">John Doe</span></p>
                </div>
              </div>
            </section>

            {/* 2. HÉBERGEMENT */}
            <section className="p-2">
              <h2 className="text-sm font-black text-slate-900 mb-4 uppercase tracking-[0.2em] flex items-center gap-2">
                <div className="w-1.5 h-6 bg-slate-200 rounded-full"></div>
                2. Hébergement
              </h2>
              <p className="text-lg">
                Le site est hébergé par la société <strong className="text-slate-900">Hostinger International Ltd.</strong><br />
                <span className="text-sm opacity-80">Siège social : 61 Lordou Vironos Street, 6023 Larnaca, Chypre.</span><br />
                <a href="https://www.hostinger.fr" target="_blank" rel="noreferrer" className="text-blue-600 font-bold hover:underline inline-block mt-2">https://www.hostinger.fr</a>
              </p>
            </section>

            {/* 3. PROPRIÉTÉ INTELLECTUELLE */}
            <section className="p-2">
              <h2 className="text-sm font-black text-slate-900 mb-4 uppercase tracking-[0.2em] flex items-center gap-2">
                <div className="w-1.5 h-6 bg-slate-200 rounded-full"></div>
                3. Propriété Intellectuelle
              </h2>
              <p>
                L'ensemble de ce site relève de la législation française et internationale sur le droit d'auteur et la propriété intellectuelle.
                Tous les droits de reproduction sont réservés, y compris pour les documents téléchargeables et les représentations iconographiques et photographiques.
                La reproduction de tout ou partie de ce site sur un support électronique quel qu'il soit est formellement interdite sauf autorisation expresse du directeur de la publication.
              </p>
            </section>

            {/* 4. RGPD */}
            <section className="bg-emerald-50/30 p-8 rounded-3xl border border-emerald-100/50 shadow-inner">
              <h2 className="text-sm font-black text-emerald-700 mb-6 uppercase tracking-[0.2em] flex items-center gap-2">
                <div className="w-1.5 h-6 bg-emerald-500 rounded-full"></div>
                4. Données Personnelles (RGPD)
              </h2>
              <p className="mb-6 text-slate-700 font-medium">
                Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez d'un droit d'accès, de rectification et de suppression des données vous concernant.
              </p>

              <div className="grid md:grid-cols-2 gap-8">
                <div className="space-y-4">
                  <h3 className="font-bold text-slate-900 flex items-center gap-2 text-sm uppercase">Données collectées en détail</h3>
                  <ul className="space-y-3 text-sm">
                    <li className="flex items-center gap-2"><div className="w-1 h-1 bg-emerald-400 rounded-full"></div> <strong>Informations de compte :</strong> email, nom, prénom.</li>
                    <li className="flex items-center gap-2"><div className="w-1 h-1 bg-emerald-400 rounded-full"></div> <strong>Données de productivité :</strong> tâches, thèmes suivis pour l'analyse IA.</li>
                    <li className="flex items-center gap-2"><div className="w-1 h-1 bg-emerald-400 rounded-full"></div> <strong>Logs de connexion :</strong> adresse IP, navigateur (pour la sécurité).</li>
                  </ul>
                </div>

                <div className="space-y-4">
                  <h3 className="font-bold text-slate-900 flex items-center gap-2 text-sm uppercase">Vos Droits détaillés</h3>
                  <ul className="grid grid-cols-1 gap-2 text-sm">
                    <li className="bg-white/60 p-2 rounded-lg border border-emerald-100/50"><strong>Accessibilité :</strong> Demander une copie de vos données.</li>
                    <li className="bg-white/60 p-2 rounded-lg border border-emerald-100/50"><strong>Rectification :</strong> Modifier des informations inexactes.</li>
                    <li className="bg-white/60 p-2 rounded-lg border border-emerald-100/50"><strong>Effacement :</strong> Droit à l'oubli et suppression de compte.</li>
                    <li className="bg-white/60 p-2 rounded-lg border border-emerald-100/50"><strong>Portabilité :</strong> Récupérer vos données au format JSON.</li>
                  </ul>
                </div>
              </div>

              <div className="mt-8 p-4 bg-white/50 rounded-2xl border border-emerald-100 text-sm text-center">
                Contact DPO : <a href="mailto:contact@quest-ia.fr" className="text-emerald-700 font-bold hover:underline">contact@quest-ia.fr</a>
              </div>
            </section>

            {/* 5. SÉCURITÉ & INFRA */}
            <section className="bg-slate-900 text-slate-300 p-8 md:p-12 rounded-[2rem] shadow-2xl relative overflow-hidden">
              <div className="absolute top-0 right-0 w-32 h-32 bg-blue-500/10 rounded-full blur-2xl"></div>
              <h2 className="text-xl font-black text-white mb-8 flex items-center gap-3">
                <ShieldCheck className="text-blue-400 w-8 h-8" />
                Sécurité & Infrastructure
              </h2>

              <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
                <div className="space-y-3">
                  <div className="p-3 bg-slate-800 w-fit rounded-xl mb-4 border border-slate-700 shadow-lg">
                    <Lock className="w-6 h-6 text-blue-400" />
                  </div>
                  <h4 className="text-white font-bold">Chiffrement Expert</h4>
                  <p className="text-sm opacity-70">Toutes les données sont chiffrées en transit (TLS 1.3) et au repos (AES-256).</p>
                </div>

                <div className="space-y-3">
                  <div className="p-3 bg-slate-800 w-fit rounded-xl mb-4 border border-slate-700 shadow-lg">
                    <Server className="w-6 h-6 text-emerald-400" />
                  </div>
                  <h4 className="text-white font-bold">Hébergement Souverain</h4>
                  <p className="text-sm opacity-70">Vos données sont hébergées exclusivement au sein de l'Union Européenne (France/Allemagne).</p>
                </div>

                <div className="space-y-3">
                  <div className="p-3 bg-slate-800 w-fit rounded-xl mb-4 border border-slate-700 shadow-lg">
                    <HardDrive className="w-6 h-6 text-purple-400" />
                  </div>
                  <h4 className="text-white font-bold">Backups Temps-Réel</h4>
                  <p className="text-sm opacity-70">Sauvegardes quotidiennes automatisées et redondantes pour prévenir toute perte.</p>
                </div>
              </div>
            </section>

          </div>

          <div className="mt-16 pt-8 border-t border-slate-100 text-center text-sm text-slate-400 font-medium">
            © {new Date().getFullYear()} Quest-IA. Tous droits réservés. <br />
            <span className="text-[10px] opacity-50 uppercase tracking-widest mt-2 block">Document Certifié conforme aux normes Européennes</span>
          </div>
        </div>
      </div>
    </div>
  );
}